import { useState } from "react";
import { useParams } from "react-router";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  Title,
  ApiRequestError,
} from "@funcional/react-ui";
import { TransactionsList } from "@pbm/transactions/components";
import { useTransactions } from "@pbm/transactions/hooks";
import {
  ProgramBeneficiaryCard,
  ProgramFamilyBeneficiarysList,
} from "@pbm/beneficiaries/components";
import { useProgramBeneficiary } from "@pbm/beneficiaries/hooks";

export default function ViewProgramBeneficiaryPage() {
  let { programCode, id }: { programCode: string; id: string } = useParams();

  const [transactionsFilters, setTransactionsFilters] = useState([]);
  const programBeneficiaryRequest = useProgramBeneficiary(programCode, id);
  const transactionsRequest = useTransactions({
    filter: {
      programCode: [programCode],
      beneficiaryId: [id],
    },
  });
  return (
    <>
      <Title>Inscrição do beneficiário</Title>

      <BreadCrumb
        items={[
          { path: "/pbm/beneficiaries", label: "Beneficiários" },
          { label: programCode },
          { label: id },
        ]}
      />

      <div>
        {programBeneficiaryRequest.status === "loading" ? (
          <ApiLoadingSpinner message="Carregando inscrição no programa..." />
        ) : programBeneficiaryRequest.status === "error" ? (
          <ApiRequestError error={programBeneficiaryRequest.error} />
        ) : (
          <>
            {programBeneficiaryRequest.data ? (
              <ProgramBeneficiaryCard
                programBeneficiary={programBeneficiaryRequest.data}
              />
            ) : (
              "Beneficiário não encontrado"
            )}
            {programBeneficiaryRequest.isFetching ? (
              <ApiUpdatingSpinner />
            ) : null}
          </>
        )}
      </div>

      <div className="mt-8">
        {programBeneficiaryRequest.status === "loading" ? (
          <ApiLoadingSpinner message="Carregando inscrições nos grupos de produtos..." />
        ) : programBeneficiaryRequest.status === "error" ? (
          <ApiRequestError error={programBeneficiaryRequest.error} />
        ) : (
          <>
            <Title level={2}>Grupos de produtos inscritos</Title>
            <ProgramFamilyBeneficiarysList
              programCode={programCode}
              data={
                programBeneficiaryRequest.data?.programFamilyBeneficiaries || []
              }
            />
            {programBeneficiaryRequest.isFetching ? (
              <ApiUpdatingSpinner />
            ) : null}
          </>
        )}
      </div>

      <div className="mt-8">
        {transactionsRequest.status === "loading" ? (
          <ApiLoadingSpinner message="Carregando transações recentes..." />
        ) : transactionsRequest.status === "error" ? (
          <ApiRequestError error={transactionsRequest.error} />
        ) : (
          <>
            <Title level={2}>Transações confirmadas recentes</Title>
            <TransactionsList
              data={(transactionsRequest.data?.edges || []).map(
                ({ node }) => node
              )}
              filters={transactionsFilters}
              setFilters={setTransactionsFilters}
            />
            {transactionsRequest.isFetching ? <ApiUpdatingSpinner /> : null}
          </>
        )}
      </div>
    </>
  );
}
